<script>
import SuperCluster from 'supercluster';
import CreateIconMixin from './CreateIcon.mixin';
export default {
	name: 'TMarkerCollection',
	inject: [ 'leaflet', 'state' ],
	mixins: [CreateIconMixin],
	props: {
		items: {
			type: Array,
			default: () => []
		},
		modal: {
			default: null,
			type: HTMLElement
		},
		iconGetter: {
			type: Function,
			default: () => () => ({})
		},
		selected: {
			type: Array,
			default: () => ([])
		},
		noCluster: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			markers: {},
			createdMarkers: [],
			cluster: null,
		};
	},
	computed: {
		popupVisible: {
			get() {
				return this.state.popup.visible;
			},
			set(value) {
				this.state.popup.visible = value;
			}
		},
		popupComponent: {
			get() {
				return this.state.popup.component;
			},
			set(value) {
				this.state.popup.component = value;
			}
		},
		tooltipVisible: {
			get() {
				return this.state.tooltip.visible;
			},
			set(value) {
				this.state.tooltip.visible = value;
			}
		},
		tooltipComponent: {
			get() {
				return this.state.tooltip.component;
			},
			set(value) {
				this.state.tooltip.component = value;
			}
		},
	},
	watch: {
		items: {
			immediate: true,
			handler() {
				this.createMarkers(this.createNodes());
			}
		},
		selected: {
			immediate: true,
			handler() {
				this.createMarkers(this.createNodes());
			}
		}
	},
	beforeDestroy() {
		this.removeMarkers();
		this.cluster = null;
		this.popupComponent = null;
		this.tooltipComponent = null;
	},
	async mounted() {
		await this.$nextTick();
		this.state.map.on('moveend', this.mapChange);
		this.state.map.on('zoomend', this.mapChange);
	},
	methods: {
		zoomToCluster(marker) {
			if (this.state.map.getZoom() < 18) {
				this.state.map.setView(marker.getLatLng(), this.state.map.getZoom() + 1);
			}
		},
		mapChange() {
			if (this.cluster) {
			  let { _northEast, _southWest } = this.state.map.getBounds();
				this.createMarkers(
					Object.freeze(this.cluster.getClusters([ _southWest.lat, _southWest.lng, _northEast.lat, _northEast.lng ], this.state.map.getZoom()))
				);
			}

			if (this.noCluster) {
				this.createMarkers(this.createNodes());
			}
		},
		removeMarkers() {
			  for (let marker of Object.values(this.markers)) {
				  marker.remove();
			  }
		},
		onClick(marker, item) {
			this.$emit('click', { marker, item });

			if (item.cluster) {
				this.zoomToCluster(marker);
				return;
			}
			if (!this.modal) return;
			if (!this.popupcomponent) this.createPopup();
			this.state.map.openPopup(this.popupcomponent, marker.getLatLng());
		},
		onMouseOver(marker, item) {
			this.$emit('mouseover', { marker, item });
		},
		onMouseOut(marker, item) {
			this.$emit('mouseout', { marker, item });
		},
		createPopup() {
			  this.popupcomponent = this.leaflet.popup({ closeButton: false, offset: [ 0, -10 ] }).setContent(this.modal);
		},
		spiderify(
			marker,
			// item
		) {
			console.log(marker);
		},
		createMarkers(nodes) {
			this.removeMarkers();
			let createdMarkers = [];
			let mapNodes = Object.freeze(nodes.map(({ geometry: { coordinates }, properties }) => ({ latitude: coordinates[0], longitude: coordinates[1], ...properties })));
			for (let { latitude, longitude, selected, ...item } of mapNodes) {
				createdMarkers.push({
					element: (createElement) => createElement('leaflet-marker', {
						props: {
							latitude: Number(latitude),
							longitude: Number(longitude),
							data: item,
							icon: this.getIcon(item, selected)
						},
						on: {
							click: (marker, item) => this.onClick(marker, item),
							contextmenu: (marker, item) => this.spiderify(marker, item),
							mouseover: (marker, item) => this.onMouseOver(marker, item),
							mouseout: (marker, item) => this.onMouseOut(marker, item),
							marker: (marker) => {
								let { lng, lat } = marker.getLatLng();
								this.markers[`${lng}:${lat}`] = marker;
							}
						}
					}),
					latitude: Number(latitude),
					longitude: Number(longitude),
				});
			}
			this.createdMarkers = Object.freeze(createdMarkers);
		},
		createNodes() {
			let points = {
				type: 'FeatureCollection',
				features: []
			};

			this.items.forEach(item => {
				points.features.push({
					type: 'Feature',
					id: item.id,
					geometry: {
						type: 'Point',
						coordinates: [ item.latitude, item.longitude ]
					},
					properties: {
						selected: this.selected.includes(item.id),
						...item
					}
				});
			});

			if (this.noCluster) {
				return Object.freeze(points.features);
			}

			this.cluster = new SuperCluster({
				radius: 43,
				maxZoom: 18,
			});


			this.cluster.load(points.features);

			let { _northEast, _southWest } = this.state.map.getBounds();
			return Object.freeze(this.cluster.getClusters([ _southWest.lat, _southWest.lng, _northEast.lat, _northEast.lng ], this.state.map.getZoom()));
		},
		getIcon(item, selected, options) {
			let icon = this.iconGetter(item, selected);
			return this.createIcon({ badgeCount: (item.cluster ? item.point_count : undefined), ...icon, ...options });
		},
	},
	render(createElement) {
		if (!this.state.map) return null;
		return this.createdMarkers.length ? createElement('div', { class: 'marker-collection' }, this.createdMarkers.map(({ element }) => element.call(this, createElement))) : null;
	}
};
</script>
